package com.zi.support.web

import com.zi.support.shared.DeviceCalls
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.Event

/**
 * Calling a Support App phone from the web (Locations > "Make a call"): the shared call page (DeviceCalls.CALL_PAGE) in a
 * popup. The browser only places calls; phones answer them in the Support App.
 */
internal object CallScreen {
    fun call(deviceId: String, name: String) {
        modal("Call $name", "<iframe id=\"call-frame\" class=\"call-frame\" title=\"Call\" allow=\"microphone; autoplay\"></iframe>", "", extraClass = "call-modal", layered = true)
        val frame: dynamic = element("call-frame") ?: return
        var callId = ""
        var stopDoc: dynamic = null
        var hungUp = false
        lateinit var listener: (Event) -> Unit
        fun cleanUp() { window.removeEventListener("message", listener); cancelListener(stopDoc) }
        fun hangUp(reason: String = "") {
            if (hungUp || callId.isBlank()) return
            hungUp = true
            promise(FirebaseGateway.callable("updateDeviceCall", json("callId" to callId, "action" to "end", "reason" to reason)), {}, {})
        }
        frame.onload = {
            frame.contentWindow.showCall(json("mode" to "outgoing", "name" to name))
            promise(FirebaseGateway.callable("startDeviceCall", json("deviceId" to deviceId, "name" to name)), { result ->
                callId = result.data.callId as String
                frame.contentWindow.joinCall(result.data.url, result.data.token)
                // The other side declining or hanging up ends this screen too.
                stopDoc = FirebaseGateway.firestore.onSnapshot(FirebaseGateway.firestore.doc(FirebaseGateway.db, "${DeviceCalls.COLLECTION}/$callId"), { snap: dynamic ->
                    DeviceCalls.endReason(field(snap.data(), "status"), isCaller = true)?.let { hungUp = true; frame.contentWindow.endCall(it) }
                }, { _: dynamic -> })
            }, { message -> frame.contentWindow.endCall(message) })
        }
        showPage(frame, DeviceCalls.CALL_PAGE)
        listener = fn@{ event ->
            val current: dynamic = element("call-frame") ?: run { hangUp(); cleanUp(); return@fn }
            val data: dynamic = event.asDynamic().data
            if (event.asDynamic().source != current.contentWindow || data == null || jsTypeOf(data.call) != "string") return@fn
            val message: dynamic = JSON.parse(data.call as String)
            when (message.type as String) {
                "hangup" -> hangUp(field(message, "reason"))
                "close" -> { hangUp(); cleanUp(); closeModal() }
            }
        }
        window.addEventListener("message", listener)
        // The popup's X hangs up too.
        document.querySelector(".call-modal .modal-close")?.addEventListener("click", { hangUp(); cleanUp() })
    }
}
